module.exports = __webpack_public_path__ + "static/mtb-p-1-b04a4acc0cfef201c543680ce8d8d9c8.png";